import { Typography } from "matsuri-ui"
import { AddressWithCopy } from "@/parts/OperationInfo/AddressWithCopy"
import { usePlacementAddressByOperationId } from "@/hooks/usePlacementAddressByOperationId"
import { PlacementType } from "@/model/placement"
import { useTranslation } from "@/hooks/useTranslation"

const addressLabels = {
    listing: "物件住所",
    commonArea: "共用部住所"
} as const satisfies Record<PlacementType, string>

const getAddressLabel = (placementType: PlacementType) => {
    return addressLabels[placementType]
}

export const PlacementAddress = ({
    operationId,
    placementType
}: {
    operationId: string
    placementType: PlacementType
}) => {
    const { t } = useTranslation()
    const { data: placementAddress } =
        usePlacementAddressByOperationId(operationId)

    return (
        <div>
            <Typography bolder>{t(getAddressLabel(placementType))}</Typography>
            <AddressWithCopy address={placementAddress?.address} />
        </div>
    )
}
